 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Home~Pagina":"Home~Pagina","Home":"Home","Pagina":"Pagina","Aside":"Aside","AsideImage":"AsideImage","AsideVideo":"AsideVideo","BannerHome":"BannerHome","BannerPagina":"BannerPagina","BlockContato":"BlockContato","BlockLocalizacao":"BlockLocalizacao","BlockPlanos":"BlockPlanos","BlockTextoCarrousel":"BlockTextoCarrousel","BlockTextoImagem":"BlockTextoImagem","BlockTextoImagemFull":"BlockTextoImagemFull","BlockTextoInformacoes":"BlockTextoInformacoes","BlockTitulo":"BlockTitulo","Citacao":"Citacao","FormularioContato":"FormularioContato","Galeria":"Galeria","GaleriaNavLateral":"GaleriaNavLateral","GaleriaNavVertical":"GaleriaNavVertical","GaleriaSimples":"GaleriaSimples","Gastronomia":"Gastronomia","Imagem":"Imagem","ImagemELegendas":"ImagemELegendas","Informacoes":"Informacoes","Mapa":"Mapa","Plano":"Plano","TextoSimples":"TextoSimples","Titulo":"Titulo","Tratamento":"Tratamento"}[chunkId]||chunkId) + "." + {"Home~Pagina":"0f995238","Home":"912e2854","Pagina":"a699c660","Aside":"5d68ac7e","AsideImage":"66677935","AsideVideo":"df5efcd6","BannerHome":"e6633765","BannerPagina":"d8fc905c","BlockContato":"ee6cf084","BlockLocalizacao":"00f06e5b","BlockPlanos":"ff662883","BlockTextoCarrousel":"f49512f9","BlockTextoImagem":"499fc8f2","BlockTextoImagemFull":"73f2688b","BlockTextoInformacoes":"86ae960f","BlockTitulo":"dc18de37","Citacao":"9b8108a4","FormularioContato":"62011d00","Galeria":"40c07f1c","GaleriaNavLateral":"bf288fee","GaleriaNavVertical":"35e332aa","GaleriaSimples":"985d40d6","Gastronomia":"61f69d20","Imagem":"c884470a","ImagemELegendas":"7f3af4d7","Informacoes":"31535002","Mapa":"c3d2ef09","Plano":"cf417687","TextoSimples":"189025b9","Titulo":"7a08a59d","Tratamento":"0febb563"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Home":1,"Pagina":1,"Aside":1,"AsideImage":1,"AsideVideo":1,"BannerHome":1,"BannerPagina":1,"BlockContato":1,"BlockLocalizacao":1,"BlockPlanos":1,"BlockTextoCarrousel":1,"BlockTextoImagem":1,"BlockTextoImagemFull":1,"BlockTextoInformacoes":1,"BlockTitulo":1,"Citacao":1,"FormularioContato":1,"Galeria":1,"GaleriaNavLateral":1,"GaleriaNavVertical":1,"GaleriaSimples":1,"Gastronomia":1,"Imagem":1,"ImagemELegendas":1,"Informacoes":1,"Mapa":1,"Plano":1,"TextoSimples":1,"Titulo":1,"Tratamento":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Home~Pagina":"Home~Pagina","Home":"Home","Pagina":"Pagina","Aside":"Aside","AsideImage":"AsideImage","AsideVideo":"AsideVideo","BannerHome":"BannerHome","BannerPagina":"BannerPagina","BlockContato":"BlockContato","BlockLocalizacao":"BlockLocalizacao","BlockPlanos":"BlockPlanos","BlockTextoCarrousel":"BlockTextoCarrousel","BlockTextoImagem":"BlockTextoImagem","BlockTextoImagemFull":"BlockTextoImagemFull","BlockTextoInformacoes":"BlockTextoInformacoes","BlockTitulo":"BlockTitulo","Citacao":"Citacao","FormularioContato":"FormularioContato","Galeria":"Galeria","GaleriaNavLateral":"GaleriaNavLateral","GaleriaNavVertical":"GaleriaNavVertical","GaleriaSimples":"GaleriaSimples","Gastronomia":"Gastronomia","Imagem":"Imagem","ImagemELegendas":"ImagemELegendas","Informacoes":"Informacoes","Mapa":"Mapa","Plano":"Plano","TextoSimples":"TextoSimples","Titulo":"Titulo","Tratamento":"Tratamento"}[chunkId]||chunkId) + "." + {"Home~Pagina":"31d6cfe0","Home":"e8f811e0","Pagina":"ad0d8722","Aside":"1fe615b6","AsideImage":"80553806","AsideVideo":"5e25e215","BannerHome":"bce653ba","BannerPagina":"044a8415","BlockContato":"f5930559","BlockLocalizacao":"4c52d80b","BlockPlanos":"f1256396","BlockTextoCarrousel":"543c01dc","BlockTextoImagem":"675489b6","BlockTextoImagemFull":"d878f6aa","BlockTextoInformacoes":"627c7eef","BlockTitulo":"7814b794","Citacao":"4df069ad","FormularioContato":"48f08fa8","Galeria":"0e433876","GaleriaNavLateral":"c5e32ba8","GaleriaNavVertical":"1c8e2f33","GaleriaSimples":"44cb8b45","Gastronomia":"832bb056","Imagem":"9635b66a","ImagemELegendas":"7f2b4a88","Informacoes":"dc1b3b29","Mapa":"9b59426d","Plano":"7c13adf1","TextoSimples":"9467ce04","Titulo":"17646b7e","Tratamento":"7d1a9264"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/SPA/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
